import React from 'react';

import Hero from './Components/Hero/'
import TextilesArea from './Components/TextilesArea/'

function App() {
  return (
    <div>
      <Hero />
      <TextilesArea />
    </div>
  );
}

export default App;
